export default {
    "首页":"Halaman Utama",
    "发展历史":"Sejarah Perkembangan",
    "资质荣誉":"Sijil & Anugerah",
    "宣传视频":"Video Promosi",
    "新闻资讯":"Berita & Maklumat",
    "产品展示":"Pameran Produk",
    "客户案例":"Kes Pelanggan",
    "下载中心":"Pusat Muat Turun",
    "联系我们":"Hubungi Kami",
    "公司":"Syarikat",
    "联系人":"Orang Hubungan",
    "传真":"Faks",
    "邮件":"E-mel",
    "邮政编码":"Kod Pos",
    "网址":"Laman Web",
    "地址":"Alamat",
    "在线留言":"Mesej Dalam Talian",
    "标题":"Tajuk",
    "请填写标题":"Sila isi tajuk",
    "姓名":"Nama",
    "请填写姓名":"Sila isi nama anda",
    "电话":"Telefon",
    "请填写电话":"Sila isi nombor telefon anda",
    "内容":"Kandungan",
    "请填写内容":"Sila isi kandungan",
    "提交消息":"Kirim Pesan",
    "邮箱":"Peti mel",
    "来源":"Sumber",
    "创建时间":"Masa Penciptaan",
    "点击量":"Jumlah Klik",
    "属于":"Milik",
    "上一条":"Sebelumnya",
    "下一条":"Seterusnya",
    "产品ID":"ID Produk",
    "购买价格":"Harga Pembelian",
    "发布时间":"Masa Penerbitan",
    "下载":"Muat Turun",
    "暂无下一条数据":"Tiada data seterusnya",
    "暂无上一条数据":"Tiada data sebelumnya",
    "登录":"Log Masuk",
}